import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_PRICE_SAGA } from "../sagaTypes";
import { loaderAction, priceFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getPriceSagaAction } from "../sagaActions";
import { PRICE_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_price`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdatePrice(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('price_id', args.data.id);
        formData.append('name', args.data.name);
        formData.append('description', args.data.description);
        formData.append('cost', args.data.cost);
        formData.append('sale', args.data.sale);
        formData.append('establishments', args.data.establishments);
        formData.append('type', args.data.type);
        formData.append('time_constraint', args.data.time_constraint);
        formData.append('coach', args.data.coach);
        formData.append('duration', args.data.duration);
        formData.append('times', args.data.times);
        formData.append('with_coach', args.data.with_coach);
        formData.append('one_time', args.data.one_time);
        formData.append('online_payment', args.data.online_payment);
        formData.append('renewal_discount', args.data.renewal_discount);
        formData.append('hide_in_app', args.data.hide_in_app);
        formData.append('first_time_pay', args.data.first_time_pay);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список цен
            yield put(getPriceSagaAction());
            // Очищаем форму цены
            yield put(priceFormAction(PRICE_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdatePrice() {
    yield takeLatest(UPDATE_PRICE_SAGA, workerUpdatePrice);
}